import { KunStateName } from "./kunSprites.generated";
import type { GenieCardData, GenieCardTone } from "./GenieChatCard";

export const KUN_SSE_ACTIVITY_EVENT = "kun:sse-activity";
// Current-item guidance replaces the previous item; null clears it on close.
export const KUN_CONTEXT_ACTIVITY_EVENT = "kun:context-activity";
export const KUN_SSE_ACTIVITY_VISIBLE_MS = 12_000;
// Give the user time to read and click when the bubble offers a link.
export const KUN_SSE_ACTIVITY_LINK_VISIBLE_MS = 20_000;
// Auto-hide mode only: an unattended hint must expire, or the mascot never leaves.
export const KUN_HINT_AUTO_DISMISS_MS = 20_000;

export interface KunSseActivity {
  id: string;
  kind: "email" | "notification" | "status";
  message: string;
  card?: GenieCardData;
  // In-app route the activity points at; rendered as a link in the bubble.
  link?: string;
  linkLabel?: string;
  // The bubble displays only the title and problem. Legacy steps and notes are
  // accepted but not rendered; `message` is the plain-text fallback.
  detail?: {
    title?: string;
    problem?: string;
    tone?: GenieCardTone;
    steps?: string[];
    note?: string;
  };
}

export interface KunOverride {
  name: KunStateName;
  token: number;
}

// Priority: override > chat activity > greeting > notification > sleep > working.
// Dragging is handled by the component (playback pause), not a state.

export type KunActivity = "thinking" | "working" | "success" | "error" | null;

export interface KunStateInputs {
  override: KunStateName | null;
  activity: KunActivity;
  greeting: boolean;
  hasUnseenHint: boolean;
  silenced: boolean;
  asleep: boolean;
}

export function getKunState(inputs: KunStateInputs): KunStateName {
  if (inputs.override) return inputs.override;
  if (inputs.activity) return inputs.activity;
  if (inputs.greeting) return "greeting";
  if (inputs.hasUnseenHint && !inputs.silenced) return "notification";
  if (inputs.asleep) return "sleep";
  // Nothing going on: idle plays a pass and then rests. "working" loops without
  // pause and is reserved for an answer actually being written.
  return "idle";
}
